// @flow
import "./nav-layout.css"

import {Card} from "material-ui/Card"
import {containers} from "@swarm2/core"
import AppBar from "material-ui/AppBar"
import Drawer from "material-ui/Drawer"
import * as React from "react"
import classnames from "classnames"
import OfflineIcon from "./OfflineIcon"
import {UpdateButton, ReleaseCountdown} from "../updates"
import * as Util from "../common"

const M = Util.intlMessages("view.NavLayout")

function Themed({children, titleProps = {showMenuIconButton: false}}: Object) {
  // The top-level card isn't really a material-design "card"; it's simply applying style/theme to the whole app.
  // The first <Card> has height=100% for pages less high than the user's screen,
  // but fails when the page needs to scroll (white bar after scrolling).
  // The second <Card> has no set height, and applies style to only part of a
  // small page (white bar at the bottom), but covers everything when scrolling.
  // The two together are enough to style the whole app.
  // (I wonder why body-styling isn't covered more clearly in material-ui's docs,
  // or did I miss it?)
  return (
    <Card className="material-nav-layout">
      <Card>
        <AppBar
          className="appBar"
          title={
            <div>
              <Util.PlainLink to="/">
                <M id="title" />
              </Util.PlainLink>
              <ReleaseCountdown />
              <UpdateButton />
              <OfflineIcon />
            </div>
          }
          {...titleProps}
        />
        {children}
      </Card>
    </Card>
  )
}

export function NavlessLayout({children}: Object) {
  return (
    <Themed>
      <div className={classnames("appContent", {docked: false})}>
        {children}
      </div>
    </Themed>
  )
}

const _NavLayout = () => null // for the react/dumped displayName
const NavLayoutDump = Util.DumpProps(_NavLayout)
export function NavLayout(props: Object) {
  const {
    drawerProps,
    drawerStyle,
    isAllowed,
    toggleOpen,
    menuItems: MenuItems,
    isError,
    children,
  } = props
  // No loading-spinner: this is the very top level, and it's important to show
  // the UI ASAP, even if it's incomplete, for the sake of the user experience.
  // Watch out for nulls below, while loading.
  const {docked} = drawerProps
  return (
    <Themed
      titleProps={{
        showMenuIconButton: !docked,
        onLeftIconButtonTouchTap: toggleOpen,
      }}
    >
      {!isError && isAllowed ? (
        <Drawer {...drawerProps} {...drawerStyle}>
          <MenuItems />
        </Drawer>
      ) : null}
      <div className={classnames("appContent", {docked: isAllowed && docked})}>
        {children}
        <NavLayoutDump {...props} />
      </div>
    </Themed>
  )
}
// 600px is the 'small' breakpoint:
// https://material.io/guidelines/layout/responsive-ui.html#responsive-ui-breakpoints
export default containers.nav.NavLayout({dockedPx: 600})(NavLayout)
//export default (props: Object) => props.children



// WEBPACK FOOTER //
// ./src/nav/MaterialNavLayout.js